import { defineStore } from 'pinia';
import type { AppException } from '@/types/common';
export const useExceptionStore = defineStore('exceptionStore', {
  state: () => {
    return {
      error: undefined as AppException | undefined,
    };
  },
  getters: {},
  actions: {
    setException(exception: AppException) {
      this.error = exception;
      // Defer @sentry/vue: report async để không kéo lib vào eager chunk qua store này;
      // set state trước nên điều hướng /error không phải chờ Sentry tải.
      void import('@sentry/vue').then((Sentry) => {
        Sentry.captureException(new Error(exception.message), {
          extra: { statusCode: exception.statusCode, errors: exception.errors },
        });
      }).catch(() => {
        // Nuốt lỗi tải chunk @sentry/vue (CSP/offline) — report là fire-and-forget, không chặn app.
      });
    },
  },
});
